import React, { useState } from 'react';

import { Tr, Td, HStack } from '@ecoinvent/ui';
import mixpanel from 'mixpanel-browser';
import { useParams } from 'react-router';

import CopyToClipboardButton from 'components/shared/CopyToClipboardButton';
import { V4LciaScore, V4TransformedLciaMethod } from 'hooks/data/datasets/V4/lcia/types';
import { useDatasetSession } from 'pages/Dataset/DatasetSessionContext';
import { MIXPANEL_EVENTS } from 'utilities/constants/mixpanel';
import { formatNumericalValue } from 'utilities/numbers';

type Props = {
  score: V4LciaScore;
  selectedMethod?: V4TransformedLciaMethod;
};

const V4ImpactAssessmentRow = ({ score, selectedMethod }: Props) => {
  const { spold_id } = useParams();
  const { increment } = useDatasetSession();

  const [hovering, setHovering] = useState(false);
  return (
    <React.Fragment>
      <Tr bg={'auto'} onMouseEnter={() => setHovering(true)} onMouseLeave={() => setHovering(false)}>
        <Td pl={0}>{score.category}</Td>
        <Td>{score.indicator}</Td>
        <Td isNumeric>{formatNumericalValue(score.amount)}</Td>
        <Td whiteSpace={'nowrap'}>{score.unit}</Td>
        <Td px={0}>
          <HStack>
            <CopyToClipboardButton
              value={score.amount}
              opacity={hovering ? 1 : 0}
              onValueCopied={() => {
                mixpanel.track(MIXPANEL_EVENTS.COPY_DATASET_VALUE, {
                  spold_id,
                  type: 'impact_score',
                  category: score.category,
                  indicator: score.indicator,
                  lcia_method: selectedMethod?.method_name,
                });
                increment('copy_dataset_value_count');
                increment('impact_assessment_action_count');
              }}
            />
          </HStack>
        </Td>
      </Tr>
    </React.Fragment>
  );
};

export default V4ImpactAssessmentRow;
